import React from "react";
import { useSelector } from "react-redux";
import { emptyStatesData } from "./EmptyStatesData";
import { Typography } from "antd";

const { Text } = Typography;

function EmptyState({ type, text, size }) {
  const emptyState = emptyStatesData.find((empty) => empty.id === type);

  if (!emptyState) {
    return (
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
        }}
      >
        <Text>Incorrect ID inputted</Text>
      </div>
    );
  }

  const EmptyStateComponent = emptyState.emptyState;
  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
      }}
    >
      <EmptyStateComponent size={size} />
      <Text>{text ? text : emptyState.text}</Text>
    </div>
  );
}

export default EmptyState;
